import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import { Icon } from '@purpurds/purpur/icon';
import { icons } from 'theme/icons';
import { purpurColorPurple600, purpurColorRed600 } from '@purpurds/tokens/color/variables';
import spacing from 'theme/spacing';
const StyledProductItemActive = styled.div `
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;
const SerialNumberList = styled.div `
  margin: ${spacing.spacing4} 0;
`;
const StyledProductItemRight = styled.div `
  position: absolute;
  right: 0;
`;
const StyledProductItemLeft = styled.div `
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex-grow: 1;
  justify-content: center;
  text-align: left;
`;
const StyledProductItemIconWrapper = styled.div `
  display: flex;
  align-items: center;
  margin-right: ${spacing.spacing8};
`;
const StyledIcon = styled(Icon) `
  margin-right: ${props => props.$isDelete ? spacing.spacing8 : '0'};
  color: ${props => props.$isDelete ? purpurColorRed600 : purpurColorPurple600};
  cursor: pointer;
`;
const ProductItemStatus = styled.span `
  font-size: 16px;
  font-weight: 300;
  color: ${purpurColorPurple600};
`;
const ProductItemSerial = styled.span `
  font-weight: 300;
  display: flex;
  flex-direction: column;
`;
export const ProductItemContentActive = ({ hasLinkOptions, name, showDeleteButton, removeProduct, leftText, serialNumbers = [], }) => (_jsxs(StyledProductItemActive, { children: [hasLinkOptions && (_jsx(StyledProductItemIconWrapper, { children: _jsx(StyledIcon, { svg: icons.link }) })), _jsxs(StyledProductItemLeft, { children: [_jsx("span", { children: name }), _jsx(ProductItemStatus, { children: leftText })] }), _jsx(SerialNumberList, { children: serialNumbers.map(serialNumber => (_jsx(ProductItemSerial, { children: serialNumber }, serialNumber))) }), _jsx(StyledProductItemRight, { children: showDeleteButton && (_jsx(StyledIcon, { "$isDelete": true, svg: icons.remove, onClick: removeProduct })) })] }));
